<template>
  <div class="hello">
    <header>
      <h1>Remo复古相机-隐私政策</h1>
      <p>最近更新日期：【2026】年【01】月【19】日。</p>
    </header>
    <section>
      <p>Remo复古相机（以下称“此产品”或“此服务”）是重庆盛纳科技有限公司（以下称“盛纳”）旗下的图像、视频制作工具，本隐私政策将向您说明，在使用APP时，您应了解的内容：</p>
      <ul>
        <li>一、我们如何收集和使用您的个人信息</li>
        <li>二、我们如何共享、储存、转让、公开披露您的个人敏感信息</li>
        <li>三、我们如何保护您的个人信息</li>
        <li>四、您的权利</li>
        <li>五、您的个人信息如何在全球范围转移</li>
        <li>六、关于第三方SDK的使用及信息收集</li>
        <li>七、适用法律及管辖</li>
        <li>八、本政策如何更新</li>
        <li>九、我们的联系方式</li>
      </ul>
      <p>我们非常重视对用户个人信息及隐私的保护，我们承诺将按业界普遍适用的安全标准，仅在必要限度范围内收集和使用您的隐私信息，并采取相应技术及管理措施加以保护。但需要特别说明的是，本政策不适用于其他第三方向您提供的产品或服务。如果您使用第三方提供的产品或服务，请关注第三方产品或服务的用户协议及隐私政策。</p>
      <p>在使用我们的产品和服务前，请您务必仔细阅读并充分了解本政策。</p>
      <h2>一、我们如何收集和使用您的个人信息</h2>
      <!-- <p>我们不收集和存储个人敏感信息，这些敏感信息包括：身份证号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14岁以下（含）未成年人的个人信息等。</p> -->
      <p>为了满足必要的服务，我们仅在应用使用时收集以下和用户有关的信息,这些信息收集时均会让用户明确授权，除此之外我们并不收集和存储其他个人敏感信息：</p>
      <ul>
        <li>
          <p>（一）使用“微信/苹果账号登录”进行账号注册，用于同步本App的支付历史记录和VIP身份。</p>
          <p>此产品将使用微信/苹果账号登录进行账号注册，注册账号时，将引导您通过微信/苹果账号登录进行账号注册，并获取您的微信昵称和头像。微信/苹果账号登录仅用于同步您在此产品中支付购买的数字增值物品或VIP身份信息，便于您在卸载App又重装后，能够找回原先的支付历史，使用付费过的增值服务，微信昵称和头像仅为了便于你确认账号登录的状态。</p>
          <p>您使用微信/苹果账号登录产品时，可选择授权在符合相关法律法规要求的前提下读取并获得您在该第三方平台上登记、公布、记录的公开信息（仅限微信昵称、头像）。</p>
          <p>微信/苹果账号登录为非必须功能，不进行登录并不影响您使用此产品中其他全部的基础功能和增值服务。</p>
          <p>除此之外，我们并不获取、存储、使用您微信账号的其他任何信息。</p>
        </li>
        <li>
          <p>（二）获取相机、读取写入设备存储、麦克风权限，使用传感器、剪贴板、发送短信的用途</p>
          <p>获取相机使用权限：作为图像和视频处理工具，我们需要您授权我们相机使用权限，用于拍摄或录制用于编辑的图片、视频素材。在整个App使用过程中，当且仅当您主动使用相机时，才会唤醒相机，我们不会在任何您不知情的情形下唤醒相机。</p>
          <p>获取读取和写入设备存储器权限：作为图像和视频处理工具，我们需要您授权我们设备数据读取和存储权限。我们仅在您主动导入手机图片、视频片段时使用设备数据读取权限，并使用存储权限将您编辑修改的素材保存回您的手机。除此之外我们并不会在您不知情的情况下，读取和写入任何信息在您的设备。</p>
          <p>麦克风权限：麦克风权限仅在您主动录制视频或添加录音片段素材进行编辑时才出现，除此之外我们不会在任何您不知情的情况下使用此权限。</p>
          <p>以上的相机、设备存储、麦克风采集到的信息，仅在设备本地使用，我们并不采集和上传服务器。</p>
          <p><b style="color:red;">当您使用拍照或者录制视频功能时，我们需要使用陀螺仪传感器、加速度传感器等设备身体传感器，传感器信息不会存储于我们的服务器中。</b></p>
          <p>应用内允许用户使用剪贴板在如下功能板块使用：</p>
          <p>-设置页反馈邮箱：复制到剪切板。</p>
          <p>-设置页用户ID：复制到剪切板。</p>
          <p>-其他涉及用户输入文本的功能板块，如允许用户自定义文案的模板功能、水印功能、作品命名功能等。</p>
          <p>发送短信主要用于发送邮件，方便用户及时报告问题。</p>
          <p>本App承诺，我们将不以任何方式采集、分析、存储、分发您剪贴板中的任何内容，也不会在非您主动发起的情况下使用您剪贴板中的任何内容。</p>
        </li>
        <li>
          <p>（三）向您提供网络安全及运营安全保障</p>
          <p>为保障您的账号、网络、运营及系统安全，预防钓鱼网站欺诈及木马病毒，在您使用本产品的过程中，我们可能会收集您的设备信息，包括不可变更的设备唯一标识（如IMEI号、IMSI码、MAC地址、IP地址；AndroidID、IDFA、GUID、SN个人信息）。</p>
        </li>
        <li>
          <p>（四）向您提供其他相关产品功能和/或服务</p>
          <p>为实现以下各项产品功能和/或服务，我们可能需要向您收集相对应的个人信息，若您拒绝提供，则无法使用该等特定服务，但不影响您正常使用基本产品功能及服务。</p>
          <ul>
            <li>1、客户服务。当您提起投诉、进行咨询或申诉时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、手机号码、电子邮件及其他有效的联系方式和个人信息。 如您拒绝提供上述信息，我们可能无法向您及时反馈相关处理结果。</li>
            <li>2、改善服务。我们会收集匿名的非个人信息，例如您的IP地址，使用的浏览器类型，浏览器的语言，您的网络请求以及请求的日期和时间。这些信息不能单独识别您的身份。非个人信息可以用于例如营销，审计，提供或改善我们的服务以及开发新服务。</li>
            <li>3、维护产品安全及时排除故障。为维护我们服务的正常运行，排查产品故障、改进及优化我们的服务，我们会收集您的设备型号信息、操作日志信息。这类信息是为提供服务必须收集的信息，收集后即作去标识化处理，不会用于识别任何特定的用户。</li>
            <li>4、在应用处于后台状态时，由于我们的某些服务将由第三方SDK提供，如产品分析服务、技术支持服务，因此我们可能会与合作伙伴共享您的某些个人信息，以保障为您提供的服务得以顺利完成，并帮助我们提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。这些信息将用于收集有关应用的使用情况和参与度，比如某个功能有多少用户使用，总体使用频次如何，便于我们后续分析优化，另外还会基于广告的投放采集用户的广告行为、部分设备信息，以及应用程序内的部分行为事件，用于广告归因，不对其他第三方提供或披露相关数据。在后台状态下可能会收集的信息如下：设备品牌、型号、软件系统版本相关信息、IMEI、IDFA、Android ID、MAC、SSID、BSSID、OAID、IMSI、UAID、ICCID、GAID、MEID、OpenUDID、GUID、SIM卡、SN个人信息、IP地址相关信息。在未获得用户同意之前，以上信息均不会进行收集。</li>
            <li>5、自启动和关联启动。为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动）能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。</li>
          </ul>
        </li>
        <li>
          <p>（五）盛纳基于其它特别情况对您的个人信息的使用</p>
          <ul>
            <li>1、如果您认为您的相关权利遭受侵犯，您可通过我们对外公布的联系方式提起投诉、举报。在此过程中，我们将要求您提供个人有效身份信息以核实投诉、举报的真实性。与此同时，如果您申请解除您的盛纳账号异常状态的，我们也可能要求您提供有效身份信息进行核实。此为个人敏感信息，我们将采取严格的保密措施，并不会向第三方进行共享。</li>
            <li>2、请您理解，我们向您提供的功能和服务是不断更新和发展的，如果我们要将您的个人信息用于本政策未载明的其它用途，或基于特定目的将收集的信息用于其它目的，我们将以合理的方式（例如页面提示、交互流程、网站公告等）向您告知，并在使用前再次征得您的同意。</li>
          </ul>
        </li>
      </ul>
      <h2>二、我们如何共享、储存、转让、公开披露您的个人信息</h2>
      <p>（一）共享</p>
      <p>我们不会与任何公司、组织、个人分享您的个人信息，但以下情况除外：</p>
      <ul>
        <li>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
        <li>2、在法定条件下共享：我们可能会根据法律法规规定、诉讼争议解决需要、按照政府主管部门或司法机关依法提出的强制要求，对外共享您的个人信息。</li>
        <li>3、在法律要求或允许的范围内，为了保护盛纳及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方。</li>
      </ul>
      <p>此外，某些为我们提供技术分析服务的合作伙伴，会向我们的用户收集基于其信息安全规则完成去标识化处理的少量个人信息，以帮助我们统计产品用户分布、评估产品推广效果，这些信息为设备信息（IMEI/IMSI/IDFA、设备型号及语言、时区、SN个人信息）。我们仅会选择管理规范的主流数据供应商，如Google、Yahoo等。尽管供应商可能发生变更，但无论如何，我们会在协议中敦促合作方遵守相关信息安全法规，切实保护用户个人数据。</p>
      <p>（二）储存</p>
      <ul>
        <li>1、信息存储地点：我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。</li>
        <li>2、信息存储期限：我们将会按照《网络安全法》、《电子商务法》规定的期限仅会在达到本政策所述目的所必需的时限内保存您的个人信息，最低期限不少于6个月，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。若超出法定保存期限后，我们会将您的个人信息删除或做匿名化处理。</li>
      </ul>
      <p>（三）转让</p>
      <p>我们将不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <ul>
        <li>1、在明确获得您的同意的前提下，我们会向其他方转让您的个人信息；</li>
        <li>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织等主体继续接受此隐私政策的约束，如果本政策约定的个人信息的收集、处理方式、使用目的等发生改变，我们将要求该公司、组织等主体重新向您征求授权同意。</li>
      </ul>
      <p>（四）公开披露</p>
      <p>我们仅会在以下情况下，收集或公开披露您的个人信息：</p>
      <ul>
        <li>1、获得您明确的同意后；</li>
        <li>2、基于法律法规、司法机关或行政主管部门的强制性要求，我们可能会披露您的个人信息。</li>
      </ul>
      <p>（五）不经授权收集、共享、转让或公开披露个人信息的例外</p>
      <p>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、共享、转让或公开披露您的个人信息。</p>
      <ul>
        <li>1、与国家安全、国防安全等国家利益直接相关的；</li>
        <li>2、与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</li>
        <li>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>4、出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</li>
        <li>5、根据您要求签订和履行合同所必需的；</li>
        <li>6、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
        <li>7、出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
        <li>8、从合法公开披露的信息中收集到的个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
        <li>9、法律法规规定的其他情形。</li>
      </ul>
      <h2>三、我们如何保护您的个人信息</h2>
      <p>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据时受SSL加密保护；我们对产品提供的配套Web服务提供HTTPS安全访问方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
      <p>我们会采取一切合理可行的措施，确保未收集无关的个人信息。</p>
      <p>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</p>
      <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
      <h2>四、您的权利</h2>
      <p>按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：</p>
      <p>访问、删除、注销、更正您的个人信息，您可以通过：</p>
      <ul>
        <li>1. 通过应用内设置页面的“注销账号”功能，进行账号注销，我们会与您进行注销的二次确认，并告知您账号注销的效果，当您最终点击【确认注销】按钮后，我们将即刻在服务器不可撤销地发起账号注销，删除正式服务器上与您当前登录账号相关的账号信息，并按照国家相关法规，在备份服务器上保留您账号的必要信息180天，这些备份信息无法用于登录、账号找回等，仅供相关部门依据法律需要时，满足必要法律程序后，才可以进行查询。</li>
        <li>2. 如果您发现应用内的账号注销功能无法成功执行时，您可以通过remo_cam@163.com向我们提出相关请求，为保障安全，在您提出上述权利主张时，您可能需要提供书面请求，或以其他方式证明您的身份。我们将在验证您的身份后再处理您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</li>
      </ul>
      <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <ul>
        <li>1、与国家安全、国防安全有关的；</li>
        <li>2、与公共安全、公共卫生、重大公共利益有关的；</li>
        <li>3、与犯罪侦查、起诉、审判和执行判决等有关的；</li>
        <li>4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</li>
        <li>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
        <li>6、涉及商业秘密的。</li>
      </ul>
      <h2>五、您的个人信息如何在全球范围内转移</h2>
      <p>我们会按照法律法规的规定，将中华人民共和国境内（以下简称“中国”）收集的用户个人信息存储于中国境内。</p>
      <p>由于我们通过遍布全球的资源和服务器向用户提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</p>
      <p>此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</p>
      <h2>六、关于第三方SDK使用及信息收集</h2>
      <p>仅为实现本政策中声明的目的，我们的某些服务将由第三方SDK提供，如产品分析服务、技术支持服务等。我们可能会与合作伙伴共享您的某些个人信息，以保障为您提供的服务得以顺利完成，并帮助我们提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。</p>
      <p>我们将您在使用本App过程中可能使用到的第三方SDK进行以下公示：</p>
      <table border="1" class="tab">
          <thead>
            <tr>
              <th>SDK 名称</th>
              <th>公司名称</th>
              <th>收集目的</th>
              <th>收集方式</th>
              <th>收集范围</th>
              <th>隐私政策</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ele, index) in info">
              <td>{{ ele.name }}</td>
              <td>{{ ele.company }}</td>
              <td>{{ ele.goal }}</td>
              <td>{{ ele.type }}</td>
              <td>{{ ele.range }}</td>
              <td class="link">
                <a :href="ele.link">{{ ele.link }}</a>
              </td>
            </tr>
          </tbody>
        </table>
        <p>我们使用的第三方SDK将按照上述表格中罗列的方式和用途收集用户数据，使用过程中遵循这些第三方SDK的隐私条款。但我们App并不在自己的服务器采集、存储、使用上方表格中罗列的用户信息。</p>
        <h2>七、适用法律及管辖</h2>
        <p>本隐私政策适用中华人民共和国大陆地区法律。本隐私政策项下争议，由被告住所地法院管辖。</p>
        <h2>八、本政策如何更新</h2>
        <p>我们的隐私政策可能会根据业务的调整、法律法规或政策的变化而适时变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在应用内发布本政策最新版本。</p>
        <p>若您不同意修改后的隐私政策，您有权并应立即停止使用我们的产品和/或服务。如果您继续使用我们的产品和/或服务，则视为您接受我们对本政策相关条款所做的修改。</p>
        <p>若隐私政策存在重大变更，我们将在应用内发布本政策最新版本，并通过在应用内弹窗的方式通知您。</p>
        <p>本政策所指的重大变更包括但不限于：</p>
        <ul>
          <li>1、我们处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等发生变化；</li>
          <li>2、您参与个人信息处理方面的权利及其行使方式发生变化；</li>
          <li>3、个人信息安全影响评估报告表明存在风险时。</li>
        </ul>
        <h2>九、我们的联系方式</h2>
        <p>如果您在使用本软件过程中有任何疑问、意见、建议，可发送邮件至remo_cam@163.com与我们取得联系。</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      info: [
        {
          name: "微信开放平台 SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "支持微信授权登录、微信分享、微信支付",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（IMEI、IDFA、Android ID、MAC、OAID），网络访问获取Wi-Fi，写入外部存储",
          link: "https://www.tencent.com/zh-cn/privacy-policy.html",
        },
        {
          name: "腾讯bugly SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "排查崩溃问题,帮助APP提升稳定性",
          type: "调用系统相关接口自动采集",
          range:
            "获取运行中的进程，应用信息：应用标识符、Android ID、设备序列号build_serial、IMEI、IDFA",
          link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
        },
        {
          name: "友盟+(com.umeng.commonsdk)",
          company:"友盟同欣（北京）科技有限公司",
          goal: "进行APP运营统计与分析、基础反作弊服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID/SN）、位置信息、网络信息",
          link: "https://www.umeng.com/page/policy",
        },
        {
          name: "友盟Ushare",
          company:"友盟同欣（北京）科技有限公司",
          goal: "分享服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)以及需要分享的社交账号公开信息、设备应用安装列表信息、地理位置信息",
          link: "https://www.umeng.com/page/policy",
        },
        {
          name: "巨量引擎转化 SDK",
          company:"北京巨量引擎网络技术有限公司",
          goal: "保障软件与服务的安全运行以及优化产品体验，广告监测归因、广告投放统计分析、反作弊，减少App崩溃、提供稳定可靠的服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志，设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、MAC、OAID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）、地理位置信息，网络访问，获取WiFi状态、设备应用安装列表信息，运营商信息、设备时区、sim卡信息 ",
          link: "https://bytedance.larkoffice.com/docx/PfdrdczIHo0wjex3Qwdce5wYnzh",
        },
        {
          name: "Xinstall SDK",
          company: "厦门数亿未来科技有限公司",
          goal: "应用数据统计、智能传参统计、渠道数据统计、分享数数据统计、作弊防护",
          type: "SDK自行采集、调用系统相关接口自动采集",
          range:
            "设备信息：设备名称、操作系统、屏幕宽高分辨率、粘贴板(剪切板)信息、设备传感器(传感器数量)；网络信息：IP地址、时区偏移量；应用信息：应用标识符、Android ID、设备序列号(SerialNumber)、IMEI、IDFA",
          link: "https://www.xinstall.com/privacy/?from=index",
        },
        {
          name: "增长营销套件 SDK",
          company: "北京火山引擎科技有限公司",
          goal: "保障软件与服务的安全运行以及优化产品体验，广告监测归因、广告投放统计分析、反作弊，减少App崩溃、提供稳定可靠的服务",
          type: "调用系统相关接口自动采集",
          range:
            "进程信息、设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志，设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）、地理位置信息，网络访问，获取WiFi状态、设备应用安装列表信息，运营商信息、设备时区、sim卡信息",
          link: "https://www.volcengine.com/docs/6285/72216",
        },
        {
          name: "MSA移动安全联盟SDK",
          company: "中国信息通信研究院",
          goal: "生成设备唯一标识符",
          type: "调用系统相关接口自动采集",
          range:
            "品牌信息，网络信息，应用软件信息",
          link: "https://www.msa-alliance.cn/col.jsp?id=122",
        },
        {
          name: "Xinstall统计",
          company: "杭州数爆科技有限公司",
          goal: "应用数据统计、智能传参统计、渠道数据统计、分享数数据统计、作弊防护	",
          type: "SDK自行采集、调用系统相关接口自动采集",
          range:
            "设备信息：设备名称、操作系统、屏幕宽高分辨率、粘贴板(剪切板)信息、设备传感器(传感器数量)；网络信息：IP地址、时区偏移量；应用信息：应用标识符、Android ID、设备序列号(SerialNumber)、IMEI、IDFA	",
          link: "https://www.xinstall.com/privacy/?from=index",
        },
        {
          name: "移动安全联盟 OAID",
          company: "中国信息通信研究院泰尔终端实验室、移动安全工作委员会",
          goal: "获取系统唯一标识码",
          type: "调用系统相关接口自动采集",
          range:
            "App包名及签名信息、设备制造商、设备型号、设备品牌、OAID、VAID、AAID",
          link: "https://www.msa-alliance.cn/col.jsp?id=122",
        },
        {
          name: "360加固SDK",
          company: "北京鸿享技术服务有限公司",
          goal: "用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（Android ID、OAID）",
          link: "https://jiagu.360.cn/#/global/help/322",
        }
      ],
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}

h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>





// WEBPACK FOOTER //
// src/components/HelloWorld.vue